import { useCallback } from 'react';
import { useGetCountryByCode } from 'store/features/directories';
import { useGetFilteredStations } from 'features/stations';
import { useRouteStationServicesFilterContext } from '../context';

import { Station } from 'dataSources/Typicode/stations/types/station';

export const useGetRouteCountriesStations = () => {
  const getCountryByCode = useGetCountryByCode();
  const getFilteredStations = useGetFilteredStations();
  const {
    isActiveAllFilter,
    isActiveTop5Filter,
    isActiveEvery100kmFilter
  } = useRouteStationServicesFilterContext();

  const getRouteCountriesStations = useCallback((
    countryCodes: string[] = [],
    stations: Station[] = [],
    services: number[] = [],
    priceType: string
  ) => {
    if (isActiveAllFilter || isActiveTop5Filter) {
      return countryCodes.reduce((acc, routeCountryCode) => {
        const country = getCountryByCode(routeCountryCode);
        const countryStations = stations.filter(({ code }) => code.toUpperCase().startsWith(routeCountryCode.toUpperCase()));
  
        acc.push({
          countryName: country ? country.name : routeCountryCode,
          // @ts-ignore
          stations: getFilteredStations(
            countryStations,
            services,
            priceType
          )
        });
        
        return acc;
      }, [] as { countryName: string; stations: Station[]; }[]);
    }

    if (isActiveEvery100kmFilter) {
      const filteredStations = getFilteredStations(stations, services, priceType);

      return countryCodes.reduce((acc, routeCountryCode) => {
        const country = getCountryByCode(routeCountryCode);
        // @ts-ignore
        const countryStations = filteredStations.filter(({ code } = {}) => code.toUpperCase().startsWith(routeCountryCode.toUpperCase()));

        acc.push({
          countryName: country ? country.name : routeCountryCode,
          // @ts-ignore
          stations: countryStations
        });

        return acc;
      }, [] as { countryName: string; stations: Station[]; }[]);
    }

    return [];
  }
    
  , [
    getCountryByCode,
    getFilteredStations,
    isActiveAllFilter,
    isActiveTop5Filter,
    isActiveEvery100kmFilter
  ]);

  return getRouteCountriesStations;
};
